import { useEffect, useState } from "react";
import {
  Form,
  Input,
  DatePicker,
  TimePicker,
  AutoComplete,
  Select,
  Checkbox,
} from "antd";
import "./EventAgendas.scss";
import { DeleteOutlined, DownOutlined, UpOutlined } from "@ant-design/icons";
import AccordionIcon from "../../assets/agendas-accordion-icon.png";
import { getAllParticipants } from "../../services/ParticipantService";
import { AxiosResponse } from "axios";
import TextArea from "antd/es/input/TextArea";
import { getAllLecturersInEvent } from "../../services/EventService";
import { formatDate, formatTime } from "../../core/Utility";
import moment from "moment";
import dayjs from "dayjs";
import { Editor } from "primereact/editor";

const EventAgendas = (props: any) => {
  const [show, setShow] = useState<boolean>(false);
  const [HTMLtext, setHTMLText] = useState<any>(
    props?.event?.agendas[props.name]?.content || ""
  );
  const { RangePicker } = DatePicker;

  const handleShowAccordion = () => {
    return setShow(!show);
  };

  const [oneAgenda, setOneAgenda] = useState<any>();

  const [selectParticipant, setSelectParticipant] = useState<any>();
  const [selectedParticipantBiography, setSelectedParticipantBiography] =
    useState("mm");
  const [selectedDate, setSelectedDate] = useState<any>(
    props?.event?.agendas[props.name]?.date
  );
  const [selectedTime, setSelectedTime] = useState<any>([null, null]);
  const handleDateChange = (date: any) => {
    setSelectedDate(date);
  };

  // useEffect(() => {
  //   let mapParticipants = props.allParticipants.map((participant: any) => {
  //     return {
  //       label: participant.nameAndSurname,
  //       value: participant.nameAndSurname,
  //       id: participant.id,
  //     };
  //   });
  //   setParticipantOptions(mapParticipants);
  //   setAllParticipants(props.allParticipants);
  // }, []);

  useEffect(() => {
    if (selectedDate) {
      let agendas = props.form.getFieldValue("agendas");
      const mapData = agendas.map((el: any, i: any) => {
        if (i === props.name && el?.time) {
          let selectDateFrom = new Date(selectedDate);
          const firstHours = new Date(el?.time[0].$d).getHours();
          const firstMinutes = new Date(el?.time[0].$d).getMinutes();
          selectDateFrom.setHours(firstHours);
          selectDateFrom.setMinutes(firstMinutes);
          let selectDateTo = new Date(selectedDate);
          const secondHours = new Date(el?.time[1].$d).getHours();
          const secondMinutes = new Date(el?.time[1].$d).getMinutes();
          selectDateTo.setHours(secondHours);
          selectDateTo.setMinutes(secondMinutes);

          setSelectedTime([selectDateFrom, selectDateTo]);

          return { ...el, time: [dayjs(selectDateFrom), dayjs(selectDateTo)] };
        } else {
          return el;
        }
      });
      props.form.setFieldValue("agendas", mapData);
    }
  }, [selectedDate]);

  // function selectParticipantFunc(option: any) {
  //   let filter: any = props.allParticipants?.find(
  //     (par: any) => par.id == option.id
  //   );
  //   setSelectParticipant(filter);
  //   setSelectedParticipantBiography(filter.biography);

  //   const updatedAgendas = props.form
  //     .getFieldValue("agendas")
  //     .map((agenda: any, index: any) => {
  //       if (index === props.restField.fieldKey) {
  //         return {
  //           ...agenda,
  //           biography: filter.biography,
  //           instructorCompanyName: filter.registration_registrationCompanyName,
  //           event: { id: props.eventId },
  //           participant: { id: filter.id },

  //         };
  //       }
  //       return agenda;
  //     });
  //   setOneAgenda(updatedAgendas);
  //   props.form.setFieldsValue({ agendas: updatedAgendas });
  // }

  const handleDisabledDates = (current: any) => {
    if (props?.event?.date) {
      const from = props.event.date[0].$d;
      const to = props.event.date[1].$d;

      let newDateFrom = moment(from, "DD-MM-YYYY");
      let newDateTo = moment(to, "DD-MM-YYYY").add(1, "days");

      return newDateFrom >= current.$d || newDateTo <= current.$d;
    } else {
      return false;
    }
  };

  const oneAgendaP =
    props.form.getFieldValue("agendas")[props.restField.fieldKey];

  let agendaTitle = `${
    oneAgendaP?.date && formatDate(new Date(oneAgendaP?.date))
  } ${oneAgendaP?.time && formatTime(new Date(oneAgendaP?.time[0]))}h - ${
    oneAgendaP?.time && formatTime(new Date(oneAgendaP?.time[1]))
  }h ${oneAgendaP?.instructorName ? `, ${oneAgendaP?.instructorName}` : ""} ${
    oneAgendaP?.instructorCompanyName
      ? `, ${oneAgendaP?.instructorCompanyName}`
      : ""
  },`;

  const limitedHTMLtext =
    HTMLtext?.length > 80 ? HTMLtext?.slice(0, 80) + "..." : HTMLtext;

  const htmlObject = {
    __html: `<html><body>${
      limitedHTMLtext == null ? "" : limitedHTMLtext
    }</body></html>`,
  };

  const handleTimeChange = (time: any) => {
    let selectDateFrom = new Date(selectedDate);
    selectDateFrom.setHours(time[0].hour());
    selectDateFrom.setMinutes(time[0].minute());

    let selectDateTo = new Date(selectedDate);
    selectDateTo.setHours(time[1].hour());
    selectDateTo.setMinutes(time[1].minute());

    setSelectedTime([selectDateFrom, selectDateTo]);

    let agendas = props.form.getFieldValue("agendas");
    const mapData = agendas.map((el: any, i: any) => {
      if (i == props.name) {
        return { ...el, time: [dayjs(selectDateFrom), dayjs(selectDateTo)] };
      } else {
        return el;
      }
    });
    props.form.setFieldValue("agendas", mapData);
  };

  const changeHTMLFunc = (value: any) => {
    let agendas = props.form.getFieldValue("agendas");
    const mapData = agendas.map((el: any, i: any) => {
      /////
      const separatedText = value.replace(/<\/p>/g, "</p>\n");

      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = separatedText;

      const text = tempDiv.textContent || tempDiv.innerText;

      if (tempDiv.parentNode) {
        tempDiv.parentNode.removeChild(tempDiv);
      }
      ////

      if (i == props.name) {
        return { ...el, content: value, title: text };
      } else {
        return el;
      }
    });
    props.form.setFieldValue("agendas", mapData);
  };

  return (
    <div className="event-agendas">
      <div className="accordion">
        <div
          onClick={() => {
            handleShowAccordion();
          }}
          className={"accordion-item"}
        >
          <div className="header-box">
            <img src={AccordionIcon} />
            <p className="accordion-header" style={{ marginLeft: "10px" }}>
              {oneAgendaP == undefined ? "Nova Agenda" : agendaTitle}
              <div
                style={{ marginLeft: "8px" }}
                dangerouslySetInnerHTML={htmlObject}
              />
            </p>
          </div>
          <div style={{ marginRight: "10px" }} className="button-open">
            {show ? (
              <UpOutlined className="icon" />
            ) : (
              <DownOutlined className="icon" />
            )}
          </div>
        </div>
      </div>
      <div className={show ? "inner-container-agenda" : "close"}>
        <Form.Item
          {...props.restField}
          name={[props.name, "date"]}
          label="Datum prezentacije:"
          rules={[
            {
              required: true,
              message: "Potrebno je uneti datum prezentacije!",
            },
          ]}
        >
          <DatePicker
            className="range-date"
            style={{ width: "100%" }}
            // showTime={false}
            format="YYYY-MM-DD"
            disabledDate={handleDisabledDates}
            onChange={handleDateChange} // Praćenje odabranog datuma
          />
        </Form.Item>
        <Form.Item
          {...props.restField}
          name={[props.name, "time"]}
          label="Vreme trajanja:"
          rules={[
            {
              required: true,
              message: "Potrebno je uneti vreme trajanja!",
            },
          ]}
        >
          <TimePicker.RangePicker
            className={selectedDate ? "range-date" : "range-date-disabled"}
            format="HH:mm"
            value={selectedTime}
            onChange={handleTimeChange}
          />
        </Form.Item>
        {/* <Form.Item
          {...props.restField}
          name={[props.name, "instructorName"]}
          label="Ime i prezime predavača:"
          // rules={[
          //   {
          //     required: true,
          //     message: "Potrebno je uneti ime i prezime predavača!",
          //   },
          // ]}
        >
          <AutoComplete
            allowClear={true}
            options={props?.participantOptions}
            className="input-label"
            onSelect={(value, option: any) => {
              selectParticipantFunc(option);
            }}
            placeholder="Unesite ime i prezime predavača"
            filterOption={(inputValue, option) =>
              option!.value.toUpperCase().indexOf(inputValue.toUpperCase()) !==
              -1
            }
          />
        </Form.Item> */}
        {/* <Form.Item
          {...props.restField}
          name={[props.name, "instructorCompanyName"]}
          label="Pravno lice:"
          // rules={[
          //   {
          //     required: true,
          //     message: "Potrebno je uneti pravno lice!",
          //   },
          // ]}
        >
          <Input className="input-label" placeholder="Unesite pravno lice" />
        </Form.Item> */}
        {/* <Form.Item
          className="title"
          {...props.restField}
          name={[props.name, "title"]}
          label="Naslov prezentacije:"
          rules={[
            {
              required: true,
              message: "Potrebno je uneti naslov prezentacije!",
            },
          ]}
        >
          <Input
            className="input-label"
            placeholder="Unesite naslov prezentacije"
          />
        </Form.Item> */}
        <Form.Item
          name={[props.name, "block"]}
          label="Block:"
          valuePropName="checked"
        >
          <Checkbox className="input-label" type="checkbox" />
        </Form.Item>
        <Form.Item
          className="content"
          {...props.restField}
          name={[props.name, "content"]}
          label="Unesite agendu:"
        >
          <Editor
            value={HTMLtext}
            onTextChange={(e) => {
              setHTMLText(e.htmlValue);
              changeHTMLFunc(e.htmlValue);
            }}
            style={{ height: "320px" }}
            placeholder="Unesite sadržaj agende..."
          />
        </Form.Item>
        {/* <Form.Item
          className="biografy"
          {...props.restField}
          name={[props.name, "biography"]}
          label="Biografija predavaca:"
        >
          <TextArea
            className="input-label"
            placeholder="Unesite biografiju predavaca"
            value={props.form.getFieldValue([props.name, "biography"])}
            onChange={(e) =>
              props.form.setFields([
                {
                  name: [props.name, "biography"],
                  value: e.target.value,
                },
              ])
            }
          />
        </Form.Item> */}
        <div className="footer-agenda">
          <span className="btn">
            <DeleteOutlined
              onClick={() => {
                //props.remove(props.restField.fieldKey);
                const agendas = props.form.getFieldValue("agendas");
                agendas.splice(props.restField.fieldKey, 1);
                const updatedAgendas = agendas.map((agenda: any) => {
                  return agenda;
                });

                props.form.setFieldsValue({ agendas: updatedAgendas });
              }}
            />
          </span>
        </div>
      </div>
    </div>
  );
};

export default EventAgendas;
